import { useCallback } from 'react';
import './nuevoStroDark.css'
import axios from 'axios';
export default function MensajesCronologiaDark({ mensaje, user }) {
    const ocultarMensaje = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(`https://back.agsseguros.online/api/ocultarCronologia`,
            {
                id: mensaje.id
            }
        ).then(async (response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [mensaje]);
    const mostrarMensaje = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(
            `https://back.agsseguros.online/api/mostrarCronologia`,
            {
                id: mensaje.id
            }
        ).then(async (response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [mensaje]);
    const borrarMensaje = useCallback(async (e) => {
        e.preventDefault()
        await axios.post(
            `https://back.agsseguros.online/api/borrarCronologia`,
            {
                id: mensaje.id
            }
        ).then(async (response) => {
            if (response) {
                window.location.reload()
            }
        })
    }, [mensaje]);
    return (
        <>
            {mensaje.borrar === 1 ?
                <></>
                :
                <div className={mensaje.oculto === 1 ? 'mensajeCronologiaMensajeOcultarDark d-flex' : 'mensajeCronologiaMensajeDark d-flex'}>
                    <div className="contenedorPrimeroCronologia">
                        <h6>{`${mensaje.fecha} | ${mensaje.hora}`}</h6>
                        <h6>{`Autor: ${mensaje.autor}`}</h6>
                        <div className='d-flex'>
                            <h6 className={mensaje.motivo === 'STRO' ? 'motivoStro center text-white' : (mensaje.motivo === 'AMP' ? 'motivoAmp center text-white' : (mensaje.motivo === 'COTI' ? 'motivoCoti center text-white' : (mensaje.motivo === 'CIA' ? 'motivoCia center text-white' : (mensaje.motivo === 'FIN' ? 'motivoFin center text-white' : ''))))}>{mensaje.motivo}</h6>
                            <h6 className={mensaje.jerarquia === 'CRG' ? 'jerarquiaCrg center text-white' : (mensaje.jerarquia === 'DEN' ? 'jerarquiaDen center text-white' : '')}>{mensaje.jerarquia}</h6>
                        </div>
                    </div>
                    <div style={{ width: '85%', paddingRight: '25px' }}>
                        <div className='d-flex'>
                            <h6>{`Desc: ${mensaje.desc}`}</h6>
                            {user === 1 || user === 53 ? <div style={{ marginLeft: 'auto' }}>
                                {mensaje.oculto === 1 ?
                                    <button style={{ display: 'block', border: 'none', background: 'none', color: 'white' }} onClick={(e) => mostrarMensaje(e)}><i class="bi bi-eye" style={{ fontSize: '18px' }}></i></button>
                                    :
                                    <button style={{ display: 'block', border: 'none', background: 'none', color: 'white' }} onClick={(e) => ocultarMensaje(e)}><i class="bi bi-eye-slash" style={{ fontSize: '18px' }}></i></button>}
                            </div> : null}
                        </div>
                        <div className='mensajeCronologiaMensaje1 d-flex'>
                            <h6>{`Obs usuario: ${mensaje.obs}`}</h6>
                            {user === 1 || user === 53 ? <div style={{ marginLeft: 'auto', paddingTop: '10px' }}>
                                <button style={{ display: 'block', border: 'none', background: 'none', color: 'white' }} onClick={(e) => borrarMensaje(e)}><i class="bi bi-trash3" style={{ fontSize: '18px' }}></i></button>
                            </div> : null}
                        </div>
                    </div>
                </div>}
        </>
    );
}
